import {Nullable} from '../../../app/TypeHelpers'
import React, {ReactNode} from 'react'
import {TableRowName} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup from '../../shared/forms/PPRadioGroup'
import {
    AVAILABLE_OR_NOT,
    DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL,
    RESERVATION_ACCEPTABILITY_FOR_RESIDENT,
    UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME,
} from '../../../CodeMaster'
import LotterySettingsComponent from './LotterySettingsComponent'
import ReservationReceptionStartTimeComponent from './ReservationReceptionStartTimeComponent'
import ReservationReceptionDeadlineComponent from './ReservationReceptionDeadlineComponent'
import ReservationCancelSettingsComponent from './ReservationCancelSettingsComponent'
import equal from 'fast-deep-equal'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'

import {TableCell, TableRow} from '@mui/material';

export interface ReservationSettings {
    residentReserve: RESERVATION_ACCEPTABILITY_FOR_RESIDENT
    lotteryAvailability: AVAILABLE_OR_NOT
    lotteryPriority: Nullable<number>
    unitOfReserveReceptionStartTime: UNIT_OF_FACILITY_RESERVATION_RECEPTION_START_TIME
    reserveReceptionStartMonth: Nullable<number>
    reserveReceptionStartDate: Nullable<number>
    unitOfReserveReceptionLimit: DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL
    reserveReceptionLimitDate: Nullable<number>
    reserveReceptionLimitTimeHours: Nullable<number>
    reserveReceptionLimitTimeMinutes: Nullable<number>
    cancelAvailability: AVAILABLE_OR_NOT
    unitOfCancelReceptionLimit: DEADLINE_UNIT_OF_RESERVATION_AND_CANCEL
    cancelReceptionLimitDate: Nullable<number>
    cancelReceptionLimitTimeHours: Nullable<number>
    cancelReceptionLimitTimeMinutes: Nullable<number>
}

interface Props extends ReservationSettings {
    eventEmitter: EventEmitterExAdmin
    handleReservationSettingsChange: (reservationSettings: ReservationSettings) => void
}

class ReservationSettingsComponent extends React.Component<Props> {

    static displayName: string = 'ReservationSettingsComponent'

    constructor(props: Readonly<Props>) {
        super(props)

        this.handleReservationAcceptabilityForResident = this.handleReservationAcceptabilityForResident.bind(this)
        this.handleReservationSettingsChange = this.handleReservationSettingsChange.bind(this)
    }

    shouldComponentUpdate(nextProps: Readonly<Props>): boolean {
        return !(this.props === nextProps || equal(this.props, nextProps))
    }

    handleReservationAcceptabilityForResident(event: React.ChangeEvent<HTMLInputElement>): void {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props
        const residentReserve: RESERVATION_ACCEPTABILITY_FOR_RESIDENT =
            RESERVATION_ACCEPTABILITY_FOR_RESIDENT.codeToEnumConstants(`${event.target.value}`)

        handleReservationSettingsChange({
            ...rest,
            residentReserve: residentReserve,
        })
    }

    handleReservationSettingsChange(reservationSettings: Partial<ReservationSettings>): void {
        const {handleReservationSettingsChange, eventEmitter, ...rest} = this.props

        handleReservationSettingsChange({
            ...rest,
            ...reservationSettings,
        })
    }

    render(): ReactNode {
        return (<>
            <TableRow>
                <TableRowName>居住者予約</TableRowName>
                <TableCell>
                    <PPRadioGroup
                        row
                        data={RESERVATION_ACCEPTABILITY_FOR_RESIDENT.values()}
                        value={this.props.residentReserve.value}
                        onChange={this.handleReservationAcceptabilityForResident}
                    />
                </TableCell>
            </TableRow>
            <LotterySettingsComponent
                lotteryAvailability={this.props.lotteryAvailability}
                lotteryPriority={this.props.lotteryPriority}
                eventEmitter={this.props.eventEmitter}
                handleReservationSettingsChange={this.handleReservationSettingsChange}
            />
            <ReservationReceptionStartTimeComponent
                unitOfReserveReceptionStartTime={this.props.unitOfReserveReceptionStartTime}
                reserveReceptionStartMonth={this.props.reserveReceptionStartMonth}
                reserveReceptionStartDate={this.props.reserveReceptionStartDate}
                eventEmitter={this.props.eventEmitter}
                handleReservationSettingsChange={this.handleReservationSettingsChange}
            />
            <ReservationReceptionDeadlineComponent
                unitOfReserveReceptionLimit={this.props.unitOfReserveReceptionLimit}
                reserveReceptionLimitDate={this.props.reserveReceptionLimitDate}
                reserveReceptionLimitTimeHours={this.props.reserveReceptionLimitTimeHours}
                reserveReceptionLimitTimeMinutes={this.props.reserveReceptionLimitTimeMinutes}
                eventEmitter={this.props.eventEmitter}
                handleReservationSettingsChange={this.handleReservationSettingsChange}
            />
            <ReservationCancelSettingsComponent
                cancelAvailability={this.props.cancelAvailability}
                unitOfCancelReceptionLimit={this.props.unitOfCancelReceptionLimit}
                cancelReceptionLimitDate={this.props.cancelReceptionLimitDate}
                cancelReceptionLimitTimeHours={this.props.cancelReceptionLimitTimeHours}
                cancelReceptionLimitTimeMinutes={this.props.cancelReceptionLimitTimeMinutes}
                eventEmitter={this.props.eventEmitter}
                handleReservationSettingsChange={this.handleReservationSettingsChange}
            />
        </>)
    }
}

export default ReservationSettingsComponent
